import React from 'react';
import _ListSocial from './_ListSocial.scss';

class ListSocialRight extends React.Component {

  render() {
    return (
      <div className="list-social">
        <a target="_blank" href="#"><img alt="Tổng đài Ban Quản trị Sàn" title="" src={require('assets/images/footer/hotline.png')} height="90"/></a>
      </div>
    );
  }
}
export default ListSocialRight;



// WEBPACK FOOTER //
// ./components/layouts/master/sub-footer/ListSocialRight.jsx